var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',[_c('div',{staticClass:"location-skeleton-root d-flex align-items-center flex-row px-1 pt-2"},_vm._l((4),function(i){return _c('div',{key:i,staticClass:"location-skeleton-item w-100 px-2"},[_c('Row',{staticClass:"image-row w-100 mb-3"}),_c('Row')],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }